import React, { useEffect, useState } from "react";
import { Formik, Field, ErrorMessage, Form } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { Checkbox, ListItemText } from "@mui/material";
import axios from "axios";
import { image, baseurl } from "../../Basurl/Baseurl";
import { GetAllStaffUser } from "../../reducer/StaffSlice";
import { GetAllCountries2 } from "../../reducer/Countries";
import { FormControl, MenuItem, OutlinedInput, Select } from "@mui/material";
import {
  staffPhoneYup,
  handleContactNumberChange,
} from "../../utils/phoneValidation";
import ActionPermissionSelect from "../../components/Staff/ActionPermissionSelect";
import {
  actionsArrayToObject,
  staffRecordToActionsArray,
} from "../../utils/staffActions";
export default function EditStaff() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { staff } = useSelector((state) => state.staff);
  const { Countries } = useSelector((state) => state.Countries);
  const [roles123, setRoles123] = useState([]);
  const [editStaff, setEditStaff] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const statusOptions = [
    "None",
    "Foundation",
    "Private",
    "Insurance",
    "Insurance + Private",
    "Referral",
  ];
  useEffect(() => {
    getRolesuser();
  }, []);
  const getRolesuser = async () => {
    try {
      const response = await axios.get(`${baseurl}getAllRoles`);
      console.log(response.data.data);
      if (response.data.data) {
        setRoles123(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    dispatch(GetAllStaffUser());
    dispatch(GetAllCountries2());
  }, [dispatch]);
  useEffect(() => {
    if (location.state?.staffID && staff.length > 0) {
      const selected = staff.find(
        (item) => item._id === location.state.staffID,
      );
      console.log(selected);
      setEditStaff(selected);
    }
  }, [location.state?.staffID, staff]);
  if (!editStaff) return <div>Loading...</div>;
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    role: Yup.string().required("Role is required"),
    phone_no: staffPhoneYup(true),
    gender: Yup.string()
      .oneOf(["Male", "Female", "Other"])
      .required("Gender is required"),
    profileImage: Yup.mixed().required("Profile image is required"),
    country: Yup.string().required("Country is required"),
    dial_code: Yup.string().required("Dial code is required"),
    password: Yup.string()
      .transform((value) => (value === "" ? undefined : value))
      .min(6, "Password must be at least 6 characters")
      .notRequired(),
    confirmPassword: Yup.string().when("password", {
      is: (password) => Boolean(password),
      then: (schema) =>
        schema
          .required("Confirm password is required")
          .oneOf([Yup.ref("password")], "Passwords must match"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("email", values.email);
      formData.append("phone_no", values.phone_no);
      formData.append("role", values.role);
      formData.append("gender", values.gender);
      formData.append("country", values.country);
      formData.append("dial_code", values.dial_code);
      formData.append(
        "roleStatuses",
        JSON.stringify(values.roleStatuses.filter(Boolean)),
      );
      formData.append(
        "accessCountries",
        JSON.stringify(values.accessCountries),
      );
      const actionObj = actionsArrayToObject(values.actions);
      formData.append("action", JSON.stringify(actionObj));
      formData.append("canEdit", String(actionObj.edit));
      formData.append("canDelete", String(actionObj.delete));
      formData.append("canExport", String(actionObj.export));
      if (values.profileImage instanceof File) {
        formData.append("profileImage", values.profileImage);
      }
      if (values.password) {
        formData.append("password", values.password);
        if (values.confirmPassword) {
          formData.append("confirmPassword", values.confirmPassword);
        }
      }
      await axios.put(`${baseurl}update_details/${editStaff._id}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
        },
      });
      Swal.fire("Success!", "Staff updated successfully", "success");
      navigate("/Admin/staff");
    } catch (error) {
      Swal.fire(
        "Error",
        error?.response?.data?.message || "Something went wrong",
        "error",
      );
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="row gx-3">
          <div className="col-md-12">
            <div className="topmainhd">
              <h6>
                <i
                  class="fa-solid fa-arrow-left-long me-2"
                  onClick={() => window.history.back()}
                ></i>
                Edit Staff
              </h6>
            </div>
          </div>
          <div className="col-md-12">
            <div className="main_content">
              <Formik
                enableReinitialize
                initialValues={{
                  email: editStaff.email || "",
                  role: editStaff.role || "",
                  gender: editStaff.gender || "",
                  phone_no: editStaff.phone_no || "",
                  name: editStaff.name || "",
                  country: editStaff.country || "",
                  dial_code: editStaff.dial_code || "",
                  profileImage: editStaff.profileImage || null,
                  roleStatuses: editStaff.roleStatuses || [],
                  accessCountries: editStaff.accessCountries || [],
                  actions: staffRecordToActionsArray(editStaff),
                  password: "",
                  confirmPassword: "",
                }}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ setFieldValue, values, isSubmitting }) => (
                  <Form>
                    <div className="row gx-3 gy-3">
                      <div className="col-md-4">
                        <div className="set-field">
                          <label>
                            Name<span className="text-danger">*</span>
                          </label>
                          <Field className="form-control" name="name" />
                          <ErrorMessage
                            name="name"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="set-field">
                          <label>
                            Email<span className="text-danger">*</span>
                          </label>
                          <Field
                            className="form-control"
                            type="email"
                            name="email"
                          />
                          <ErrorMessage
                            name="email"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="set-field">
                          <label>New Password</label>
                          <Field
                            className="form-control"
                            type="password"
                            name="password"
                            placeholder="Leave blank to keep current password"
                            autoComplete="new-password"
                          />
                          <ErrorMessage
                            name="password"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="set-field">
                          <label>Confirm Password</label>
                          <Field
                            className="form-control"
                            type="password"
                            name="confirmPassword"
                            placeholder="Re-enter new password"
                            autoComplete="new-password"
                          />
                          <ErrorMessage
                            name="confirmPassword"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="set-field">
                          <label>
                            Country<span className="text-danger">*</span>
                          </label>
                          <Field name="country">
                            {({ field, form }) => (
                              <>
                                <FormControl fullWidth size="small">
                                  <Select
                                    value={field.value}
                                    onChange={(e) => {
                                      const selectedCountry = Countries.find(
                                        (item) => item.name === e.target.value,
                                      );
                                      form.setFieldValue(
                                        "country",
                                        selectedCountry.name,
                                      );
                                      form.setFieldValue(
                                        "dial_code",
                                        selectedCountry.dial_code,
                                      );
                                    }}
                                    input={
                                      <OutlinedInput placeholder="Select Country" />
                                    }
                                    displayEmpty
                                    sx={{ height: 40 }}
                                    MenuProps={{
                                      PaperProps: { style: { maxHeight: 200 } },
                                    }}
                                  >
                                    <MenuItem value="">
                                      <em>Select Country</em>
                                    </MenuItem>
                                    {Countries?.map((con) => (
                                      <MenuItem key={con._id} value={con.name}>
                                        {con.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                                <ErrorMessage
                                  name="country"
                                  component="div"
                                  className="text-danger"
                                />
                              </>
                            )}
                          </Field>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="set-field">
                          <label>
                            Phone No<span className="text-danger">*</span>
                          </label>
                          <div className="country-code">
                            <input
                              type="text"
                              className="form-control code-dial"
                              value={values.dial_code}
                              disabled
                            />
                            <input
                              type="text"
                              className="form-control code-in"
                              name="phone_no"
                              value={values.phone_no}
                              onChange={(e) =>
                                handleContactNumberChange(
                                  e,
                                  setFieldValue,
                                  "phone_no",
                                )
                              }
                              placeholder="Enter phone number"
                            />
                          </div>
                          <ErrorMessage
                            name="phone_no"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="set-field">
                          <label>
                            Access Countries<span className="text-danger">*</span>
                          </label>
                          <FormControl fullWidth size="small">
                            <Select
                              multiple
                              name="accessCountries"
                              value={values.accessCountries}
                              onChange={(event) => {
                                const value = event.target.value;
                                if (value.includes("All")) {
                                  if (
                                    values.accessCountries.length ===
                                    Countries.length
                                  ) {
                                    setFieldValue("accessCountries", []);
                                  } else {
                                    setFieldValue(
                                      "accessCountries",
                                      Countries.map((c) => c.name),
                                    );
                                  }
                                } else {
                                  setFieldValue("accessCountries", value);
                                }
                              }}
                              renderValue={(selected) => selected.join(", ")}
                              sx={{ height: 38 }}
                              MenuProps={{
                                PaperProps: { style: { maxHeight: 300 } },
                              }}
                            >
                              <MenuItem value="All">
                                <Checkbox
                                  checked={
                                    values.accessCountries.length ===
                                    Countries.length
                                  }
                                  indeterminate={
                                    values.accessCountries.length > 0 &&
                                    values.accessCountries.length <
                                    Countries.length
                                  }
                                />
                                <ListItemText primary="Select All" />
                              </MenuItem>
                              {Countries?.map((con) => (
                                <MenuItem key={con._id} value={con.name}>
                                  <Checkbox
                                    checked={values.accessCountries.includes(
                                      con.name,
                                    )}
                                  />
                                  <ListItemText primary={con.name} />
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <ErrorMessage
                            name="accessCountries"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="set-field">
                          <label>
                            Role<span className="text-danger">*</span>
                          </label>
                          <Field
                            as="select"
                            name="role"
                            className="form-control"
                          >
                            <option value="">Select Role</option>
                            {roles123?.map((item, index) => {
                              return (
                                <option value={item.role}>{item.role}</option>
                              );
                            })}
                          </Field>
                          <ErrorMessage
                            name="role"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="set-field gender-select">
                          <label>
                            Gender<span className="text-danger">*</span>
                          </label>
                          <br></br>
                          <div className="form-check-inline">
                            <Field type="radio" name="gender" value="Male" />{" "}
                            Male
                          </div>
                          <div className="form-check-inline">
                            <Field type="radio" name="gender" value="Female" />{" "}
                            Female
                          </div>
                          <div className="form-check-inline">
                            <Field type="radio" name="gender" value="Other" />{" "}
                            Others
                          </div>
                          <ErrorMessage
                            name="gender"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="set-field">
                          <label>
                            Profile Image<span className="text-danger">*</span>
                          </label>
                          <div className="profile-upload">
                            <div className="upload-img">
                              {selectedImage ? (
                                <img
                                  src={URL.createObjectURL(selectedImage)}
                                  alt="preview"
                                />
                              ) : editStaff?.profileImage ? (
                                <img
                                  src={`${image}${editStaff.profileImage}`}
                                  alt="current"
                                />
                              ) : (
                                <img src="assets/img/user.jpg" alt="default" />
                              )}
                            </div>
                            <div className="upload-input">
                              <input
                                type="file"
                                className="form-control"
                                onChange={(e) => {
                                  setFieldValue(
                                    "profileImage",
                                    e.target.files[0],
                                  );
                                  setSelectedImage(e.target.files[0]);
                                }}
                              />
                            </div>
                          </div>
                          <ErrorMessage
                            name="profileImage"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="set-field">
                          <label>
                            Give Permission<span className="text-danger">*</span>
                          </label>
                          <FormControl fullWidth>
                            <Select
                              multiple
                              value={values.roleStatuses}
                              name="roleStatuses"
                              onChange={(event) => {
                                let value = event.target.value;
                                value = value.filter((v) => v !== "");
                                if (value.includes("All")) {
                                  if (
                                    values.roleStatuses.length ===
                                    statusOptions.length
                                  ) {
                                    setFieldValue("roleStatuses", []);
                                  } else {
                                    setFieldValue(
                                      "roleStatuses",
                                      statusOptions,
                                    );
                                  }
                                } else {
                                  setFieldValue("roleStatuses", value);
                                }
                              }}
                              renderValue={(selected) => selected.join(", ")}
                              sx={{ height: 38 }}
                              MenuProps={{
                                PaperProps: {
                                  style: { maxHeight: 337 },
                                },
                                disableAutoFocusItem: true,
                              }}
                            >
                              <MenuItem
                                className="custmselect staffpermiss"
                                value="All"
                              >
                                <Checkbox
                                  checked={
                                    values.roleStatuses.length ===
                                    statusOptions.length
                                  }
                                  indeterminate={
                                    values.roleStatuses.length > 0 &&
                                    values.roleStatuses.length <
                                    statusOptions.length
                                  }
                                />
                                <ListItemText
                                  className="custmselect"
                                  primary="Select All"
                                />
                              </MenuItem>
                              {statusOptions.map((roleStatuses) => (
                                <MenuItem
                                  className="custmselect staffpermiss"
                                  key={roleStatuses}
                                  value={roleStatuses}
                                >
                                  <Checkbox
                                    checked={
                                      values.roleStatuses.indexOf(
                                        roleStatuses,
                                      ) > -1
                                    }
                                  />
                                  <ListItemText
                                    className="custmselect"
                                    primary={roleStatuses}
                                  />
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                      <ActionPermissionSelect
                        value={values.actions}
                        onChange={(next) => setFieldValue("actions", next)}
                      />
                      <div className="col-md-12">
                        <button type="submit" className="submit-btn" disabled={isSubmitting}>
                          {isSubmitting ? "Updating..." : "Submit"}
                        </button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
